import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Key } from './keyboard.types';
import { cn } from '@gametailors/web-core/tailwind';

@Component({
  selector: 'lib-key',
  imports: [],
  template: `<button
    [disabled]="key.disabled || disabled"
    (click)="keyPress.emit(key)"
    [class]="
      cn(
        'rounded-md p-3 py-2 text-2xl disabled:opacity-25',
        !key.disabled && 'cursor-pointer',
        key.button.variant == 'text'
          ? ''
          : key.button.variant === 'outlined'
            ? 'border-surface-300 border-2 bg-white'
            : 'bg-primary-100 border-primary-400 border-2 text-black',
        this.className
      )
    "
  >
    <!-- todo: this innerHTML call is unsafe -->
    <div [innerHTML]="key.html"></div>
  </button>`,
})
export class KeyComponent {
  @Input({ required: true }) public key!: Key;
  @Input({ alias: 'class' }) public className?: string;
  @Input() public disabled = false;

  @Output() keyPress = new EventEmitter<Key>();

  // this `typeof cn` is needed, else the test script fails
  protected readonly cn: typeof cn = cn;
}
